import { render } from "./Ipv6FirewallRulesTab.vue?vue&type=template&id=c7ce7716&scoped=true"
import script from "./Ipv6FirewallRulesTab.vue?vue&type=script&lang=js"
export * from "./Ipv6FirewallRulesTab.vue?vue&type=script&lang=js"

import "./Ipv6FirewallRulesTab.vue?vue&type=style&index=0&id=c7ce7716&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7ce7716"]])

export default __exports__